<script>
    import CartElement from './CartElement'

    export default {
        props: ['userprop', 'purchaseprop', 'purchaseelementsprop', 'vouchers', 'activateurls'],
        components: {CartElement},
        data() {
            return {
                user: this.userprop,
                purchase: this.purchaseprop,
                purchaseElements: this.purchaseelementsprop,
                voucher: _.head(this.vouchers)
            }
        },
        computed: {
            companyFeeProductItems() {
                const companyFees = this.purchaseElements.filter(i => {
                    return 'App\\CompanyFee' == i.buyable_type
                })

                for (const iterator of companyFees) {
                    iterator['activateUrl'] = this.activateurls[iterator.id]
                }

                return companyFees
            },            
            defaultElements() {
                const defaultElems = this.purchaseElements.filter(i => {
                    return !['App\\CustomGiftCard', 'App\\SummerCampProduct', 'App\\CompanyFee'].includes(i.buyable_type)
                })

                for (const iterator of defaultElems) {
                    iterator['activateUrl'] = this.activateurls[iterator.id]
                }

                return defaultElems
            },
            giftCards() {
                const giftCards = this.purchaseElements.filter(i => i.buyable_type == 'App\\CustomGiftCard')

                for (const iterator of giftCards) {
                    iterator['activateUrl'] = this.activateurls[iterator.id]
                }

                return giftCards
            },
            summerCampProductItems() {
                const summerCamps = this.purchaseElements.filter(i => {
                    return 'App\\SummerCampProduct' == i.buyable_type
                })

                for (const iterator of summerCamps) {
                    iterator['activateUrl'] = this.activateurls[iterator.id]
                }

                return summerCamps
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/CartSummaryContainer.vue